import sha256 from 'crypto-js/sha256';
import hmacSHA512 from 'crypto-js/hmac-sha512';
import Base64 from 'crypto-js/enc-base64';

//analytics
import FireAnalytics from "./Firebase";
import Pixel from "./Pixel";
import PersonalizeRecord from "./Personalize";
import { Analytics as AmplifyAnalytics } from "aws-amplify";

const IS_LIVE_SITE = ~document.location.hostname.indexOf("www.kickavenue.com")
// const { Moengage } = window;
const PRODUCT_CATALOG_ID = process.env.REACT_APP_FB_CATALOG_ID;

const hashEmail = (email, privateKey) => {
  const hashDigest = sha256(email);
  const hmacDigest = Base64.stringify(hmacSHA512(hashDigest, privateKey));

  return hmacDigest;
}


//https://developers.google.com/gtagjs/reference/event
class Analytics {
  recordSignIn(method, email) {
    const privateKey = 'secret key 123';
    const hashedEmail = hashEmail(email, privateKey);

    if (!IS_LIVE_SITE) return;
    FireAnalytics.logEvent("login", {
      method
    });

    Pixel.recordCustomEvent("Login", {
      method,
      email: hashedEmail
    });

    // Moengage.add_unique_user_id("Login", {
    //   email
    // })
  }

  recordSignUp(method, email) {
    const privateKey = 'secret key 123';
    const hashedEmail = hashEmail(email, privateKey);

    if (!IS_LIVE_SITE) return;

    FireAnalytics.logEvent("sign_up", {
      method
    });
    Pixel.recordEvent("CompleteRegistration", {
      currency: "IDR",
      value: 1,
      email: hashedEmail
    });

    // Moengage.add_email("SignUp", {
    //   email
    // })
  }

  recordPurchase(
    content_name,
    content_category,
    content_ids,
    content_type,
    value,
    currency,
    user_sell_id,
    seller_id,
    invoice_number,
    product_variant_id,
    userId
  ) {
    if (!IS_LIVE_SITE) return;

    FireAnalytics.logEvent("purchase", {
      value,
      currency,
      user_sell_id,
      seller_id,
      invoice_number,
      item_id: product_variant_id
    });

    Pixel.recordEvent("Purchase", {
      content_name,
      content_category,
      content_ids,
      content_type,
      value,
      currency,
      user_sell_id,
      seller_id,
      invoice_number,
      product_catalog_id: PRODUCT_CATALOG_ID
    });

    PersonalizeRecord({
      eventType: "purchase",
      eventValue: 5,
      itemId: product_variant_id && product_variant_id.toString(),
      userId: userId && userId.toString()
    });

    // Moengage.track_event("Purchase", {
    //   content_name,
    //   content_category,
    //   content_ids,
    //   content_type,
    //   value,
    //   currency,
    //   user_sell_id,
    //   seller_id,
    //   invoice_number,
    //   product_catalog_id: PRODUCT_CATALOG_ID
    // })
  }

  recordOffer(
    content_name,
    content_category,
    content_ids,
    content_type,
    value,
    currency,
    userId,
    username,
    user_sell_id,
    // seller_id,
    product_variant_id
  ) {
    if (!IS_LIVE_SITE) return;

    FireAnalytics.logEvent("offer", {
      platform: "WEB",
      product_name: content_name,
      userId: userId,
      item_id: product_variant_id
    });
    Pixel.recordCustomEvent("Offer", {
      content_name,
      content_category,
      content_ids,
      content_type,
      value,
      currency,
      product_catalog_id: PRODUCT_CATALOG_ID,
      userId,
      username,
      user_sell_id
      // seller_id
    });

    PersonalizeRecord({
      eventType: "offer",
      eventValue: 4,
      itemId: product_variant_id && product_variant_id.toString(),
      userId: userId && userId.toString()
    });
    // Moengage.track_event("Offer", {
    //   content_name,
    //   content_category,
    //   content_ids,
    //   content_type,
    //   value,
    //   currency,
    //   product_catalog_id: PRODUCT_CATALOG_ID,
    //   userId,
    //   username,
    //   user_sell_id,
    //   seller_id
    // })
  }

  recordViewContent(
    content_name,
    content_category,
    content_ids,
    content_type,
    value,
    currency,
    userId,
    product_variant_id
  ) {
    if (!IS_LIVE_SITE) return;

    FireAnalytics.logEvent("select_content", {
      items: content_name,
      content_type,
      content_id: content_ids
    });

    Pixel.recordEvent("ViewContent", {
      content_name,
      content_category,
      content_ids,
      content_type,
      value,
      currency,
      product_catalog_id: PRODUCT_CATALOG_ID
    });

    PersonalizeRecord({
      eventType: "page_view",
      eventValue: 1,
      itemId: product_variant_id && product_variant_id.toString(),
      userId: userId && userId.toString()
    });

    // Moengage.track_event("ViewContent", {
    //   content_name,
    //   content_category,
    //   content_ids,
    //   content_type,
    //   value,
    //   currency,
    //   product_catalog_id: PRODUCT_CATALOG_ID
    // })
  }

  recordInitiateOffer(
    content_name,
    content_category,
    content_ids,
    content_type,
    value,
    currency,
    userId
    // user_sell_id,
    // seller_id
  ) {
    if (!IS_LIVE_SITE) return;

    FireAnalytics.logEvent("initiate_offer", {
      content_name,
      content_category,
      content_ids,
      content_type,
      value,
      currency,
      // user_sell_id,
      // seller_id,
      product_catalog_id: PRODUCT_CATALOG_ID
    });

    Pixel.recordCustomEvent("InitiateOffer", {
      content_name,
      content_category,
      content_ids,
      content_type,
      value,
      currency,
      // user_sell_id,
      // seller_id,
      product_catalog_id: PRODUCT_CATALOG_ID
    });

    // Moengage.track_event("InitiateOffer", {
    //   content_name,
    //   content_category,
    //   content_ids,
    //   content_type,
    //   value,
    //   currency,
    //   // user_sell_id,
    //   // seller_id,
    //   product_catalog_id: PRODUCT_CATALOG_ID
    // })
  }

  recordAddToCart(
    content_name,
    content_category,
    content_ids,
    content_type,
    value,
    currency,
    user_sell_id,
    seller_id,
    userId,
    product_variant_id
  ) {
    if (!IS_LIVE_SITE) return;

    FireAnalytics.logEvent("add_to_cart", {
      item: content_name,
      value,
      currency,
      user_sell_id,
      seller_id
    });

    Pixel.recordEvent("AddToCart", {
      content_name,
      content_category,
      content_ids,
      content_type,
      value,
      currency,
      user_sell_id,
      seller_id,
      product_catalog_id: PRODUCT_CATALOG_ID
    });

    PersonalizeRecord({
      eventType: "add_to_cart",
      eventValue: 3,
      itemId: product_variant_id && product_variant_id.toString(),
      userId: userId && userId.toString()
    });



    // Moengage.track_event("AddToCart", {
    //   content_name,
    //   content_category,
    //   content_ids,
    //   content_type,
    //   value,
    //   currency,
    //   user_sell_id,
    //   seller_id,
    //   product_catalog_id: PRODUCT_CATALOG_ID
    // })
  }

  recordPaymentCompletion(
    invoice_number,
    transfer_amount,
    name,
    transfer_date,
    bank_account_id,
    userId
  ) {
    if (!IS_LIVE_SITE) return;

    FireAnalytics.logEvent("payment_completed", {
      invoice_number,
      transfer_amount,
      name,
      transfer_date,
      bank_account_id
    });

    Pixel.recordCustomEvent("payment_completed", {
      invoice_number,
      transfer_amount,
      name,
      transfer_date,
      bank_account_id
    });
  }

  recordSliders(event_name, properties) {
    if (!IS_LIVE_SITE) return;

    FireAnalytics.logEvent(event_name, properties);
    AmplifyAnalytics.record({
      name: event_name,
      attributes: properties,
      userId: null
    }, "AmazonPersonalize");
  }

  recordSearch(
    userId,
    search_term,
    content_category
  ) {
    if (!IS_LIVE_SITE) return;

    FireAnalytics.logEvent("search", {
      userId,
      search_term,
      content_category
    });

    Pixel.recordCustomEvent("search", {
      userId,
      search_term,
      content_category
    });
  }
}

const AnalyticsWrapper = new Analytics();
export default AnalyticsWrapper;